

























import Vue from "vue";
import skipIcon from "@joyz/app-core/assets/icons/transparent/ChevronRight.svg";

interface Data {
  icons: { [key: string]: string };
}

interface Props {
  skipDisabled: boolean;
  hideSkip: boolean;
}
interface Methods {
  handleMiniSettingsClicked: () => void;
  handleSkipClicked: () => void;
}
export default Vue.extend<Data, Methods, {}, Props>({
  name: "ExerciseFooter",
  props: {
    skipDisabled: { type: Boolean, default: true },
    hideSkip: { type: Boolean, default: false }
  },
  data() {
    return {
      icons: {
        skipIcon: skipIcon,
        miniSettingsIcon: "" // placeholder for mini settings
      }
    };
  },
  methods: {
    handleMiniSettingsClicked: function() {
      this.$emit("mini-settings-clicked");
    },
    handleSkipClicked: function() {
      this.$emit("skip-clicked");
    }
  }
});
